import en from './en.json';
import enCa from './en-ca.json';
import enGb from './en-gb.json';
import es from './es.json';
import esMx from './es-mx.json';
import fr from './fr.json';
import frCa from './fr-ca.json';
import ptBr from './pt-br.json';
import ar from './ar.json';
import bg from './bg.json';
import bs from './bs.json';
import bn from './bn.json';
import cs from './cs.json';
import da from './da.json';
import de from './de.json';
import el from './el.json';
import fi from './fi.json';
import he from './he.json';
import hi from './hi.json';
import ht from './ht.json';
import hu from './hu.json';
import id from './id.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import mr from './mr.json';
import ms from './ms.json';
import nl from './nl.json';
import pa from './pa.json';
import pl from './pl.json';
import ru from './ru.json';
import sk from './sk.json';
import so from './so.json';
import sq from './sq.json';
import sv from './sv.json';
import sw from './sw.json';
import th from './th.json';
import tl from './tl.json';
import tr from './tr.json';
import ur from './ur.json';
import vi from './vi.json';
import zhCn from './zh-cn.json';
import zhTw from './zh-tw.json';
import am from './am.json';
const wrap = (json) => ({ translation: json });
const resources = {
    en: wrap(en),
    'en-ca': wrap(enCa),
    'en-gb': wrap(enGb),
    es: wrap(es),
    'es-mx': wrap(esMx),
    fr: wrap(fr),
    'fr-ca': wrap(frCa),
    'pt-br': wrap(ptBr),
    ar: wrap(ar),
    am: wrap(am),
    bg: wrap(bg),
    bn: wrap(bn),
    bs: wrap(bs),
    cs: wrap(cs),
    da: wrap(da),
    de: wrap(de),
    el: wrap(el),
    fi: wrap(fi),
    he: wrap(he),
    hi: wrap(hi),
    ht: wrap(ht),
    hu: wrap(hu),
    id: wrap(id),
    it: wrap(it),
    ja: wrap(ja),
    ko: wrap(ko),
    mr: wrap(mr),
    ms: wrap(ms),
    nl: wrap(nl),
    pa: wrap(pa),
    pl: wrap(pl),
    ru: wrap(ru),
    sk: wrap(sk),
    so: wrap(so),
    sq: wrap(sq),
    sv: wrap(sv),
    sw: wrap(sw),
    th: wrap(th),
    tl: wrap(tl),
    tr: wrap(tr),
    ur: wrap(ur),
    vi: wrap(vi),
    'zh-cn': wrap(zhCn),
    'zh-tw': wrap(zhTw),
};
export default resources;
//# sourceMappingURL=index.js.map